const $ = jQuery;

export const init = () => {
    fire_department_init_single_post_copy_link();
};

function fire_department_init_single_post_copy_link() {
    let elem = $( '.single_post_copy' );

    if ( ! elem.length ) {
        return;
    }

    elem.on( 'click', function ( e ) {
        e.preventDefault();

        let link = $( this ).attr( 'href' );
        let temp = $( '<input>' );

        $( 'body' ).append( temp );

        temp.val( link ).select();

        document.execCommand( 'copy' );
        temp.remove();

        $( this ).find( '.single_post_copy_message' ).fadeIn( function() {
            let message = $( this );

            setTimeout( function() {
                message.fadeOut();
            }, 2000 );
        } );
    } );
}
